import {
  BaseUXComponent,
  UXComponentType
} from '../../UXComponentRenderer/uxComponent.types'
import { Color, ColorValue } from '../../styles/color.styles'
import { Image } from '../Image/Image.types'

export enum IconType {
  // *** IMAGES *** //
  ContactUs = 'CONTACT_US',
  HolidayEmptyState = 'HOLIDAY_EMPTY_STATE',
  MenuNotAvailable = 'MENU_NOT_AVAILABLE_EMPTY_STATE',
  MenuNotAvailableSkipped = 'SKIPPED_EMPTY_STATE',
  SubscriptionCancelled = 'SUBSCRIPTION_CANCELLED',
  Warning = 'WARNING_TIME',
  GenericIssue = 'GENERIC_ISSUE',
  CalendarImage = 'CALENDAR_IMAGE',
  ClockImage = 'CLOCK_IMAGE',
  TruckImage = 'TRUCK_IMAGE',
  FoodBagImage = 'FOOD_BAG_IMAGE',

  // *** ICONS *** //
  AlertTriangleOutline = 'ALERT_TRIANGLE_OUTLINE',
  ArrowBackOutline = 'ARROW_BACK_OUTLINE',
  ArrowForwardOutline = 'ARROW_FORWARD_OUTLINE',
  ArrowLeft = 'ARROW_LEFT',
  ArrowRight = 'ARROW_RIGHT',
  BarChartMixed = 'BAR_CHART_MIXED',
  BillingsAndReceipts = 'BILLINGS_AND_RECEIPTS',
  BulbOutline = 'BULB_OUTLINE',
  Calendar = 'CALENDAR',
  CalendarOutline = 'CALENDAR_OUTLINE',
  CheckMarkCircleOutline = 'CHECKMARK_CIRCLE_OUTLINE',
  ChevronRight = 'CHEVRON_RIGHT',
  ChevronLeft = 'CHEVRON_LEFT',
  ChevronDown = 'CHEVRON_DOWN',
  ChevronUp = 'CHEVRON_UP',
  ClockOutline = 'CLOCK_OUTLINE',
  CloseOutline = 'CLOSE_OUTLINE',
  EditOutline = 'EDIT_OUTLINE',
  EmailOutline = 'EMAIL_OUTLINE',
  Faqs = 'FAQS',
  FoodBag = 'FOOD_BAG',
  HeartOutline = 'HEART_OUTLINE',
  HeartFilled = 'HEART_FILLED',
  InboxOutline = 'INBOX_OUTLINE',
  InfoOutline = 'INFO_OUTLINE',
  LayersOutline = 'LAYERS_OUTLINE',
  MessageCircleOutline = 'MESSAGE_CIRCLE_OUTLINE',
  MoreHorizontalOutline = 'MORE_HORIZONTAL_OUTLINE',
  MoreVerticalOutline = 'MORE_VERTICAL_OUTLINE',
  OptionsOutline = 'OPTIONS_OUTLINE',
  PaperPlaneOutline = 'PAPER_PLANE_OUTLINE',
  PeopleOutline = 'PEOPLE_OUTLINE',
  Person = 'PERSON',
  PersonOutline = 'PERSON_OUTLINE',
  PinOutline = 'PIN_OUTLINE',
  SettingsOutline = 'SETTINGS_OUTLINE',
  PlusOutline = 'PLUS_OUTLINE',
  Search = 'SEARCH',
  SearchFilled = 'SEARCH_FILLED',
  ShoppingCartOutline = 'SHOPPING_CART_OUTLINE',
  Star = 'STAR',
  StarImage = 'STAR_IMAGE',
  StarActive = 'STAR_ACTIVE',
  StartDisabled = 'STAR_DISABLED',
  StarOutline = 'STAR_OUTLINE',
  SuccessOutline = 'SUCCESS_CIRCLE',
  SuccessCheckmark = 'SUCCESS_CHECKMARK',
  TextFieldOutline = 'TEXT_FIELD_ERROR',
  Timer = 'TIMER',
  TimerOutline = 'TIMER_OUTLINE',
  ToggleRightOutline = 'TOGGLE_RIGHT_OUTLINE',
  TruckCheck = 'TRUCK_CHECK',
  PercentOutline = 'PERCENT_OUTLINE',
  WineGlass = 'WINE_GLASS',
  InfoSkipped = 'INFO_SKIPPED',

  // Meal card tags
  Spicy = 'SPICY',
  Vegetarian = 'MENU_PLANT_BASED',
  Vegan = 'PLANT_BASED',
  Restriction = 'RESTRICTION',
  NotMatch = 'AVOID',
  Premium = 'PREMIUM_TRAY',
  New = 'NEW',
  KetoDiet = 'KETO',
  PaleoDiet = 'PALEO',
  MediterraneanDiet = 'MEDITERRANEAN',
  PescatarianDiet = 'PESCATARIAN',
  LowEmissions = 'LOW_EMISSIONS',
  ClimateFriendly = 'CLIMATE_FRIENDLY',
  UnityPass = 'UNITY_PASS_LOGO',
  Strict = 'STRICT',
  Info = 'INFO',
  DietPescatarian = 'DIET_PESCATARIAN',
  DietPaleo = 'DIET_PALEO',
  DietKeto = 'DIET_KETO',
  DietMediterranean = 'DIET_MEDITERRANEAN',

  // *** MENU TAB ICONS *** //
  MenuFeaturedTab = 'MENU_FEATURED_TAB',
  MenuBreakfastTab = 'MENU_BREAKFAST_TAB',
  MenuSidesTab = 'MENU_SIDES_TAB',
  MenuDrinksTab = 'MENU_DRINKS_TAB',
  MenuMealsTab = 'MENU_MEALS_TAB',
  MenuTreatsTab = 'MENU_TREATS_TAB',
  MenuMixMatchTab = 'MENU_MIX_MATCH_TAB',
  MenuChefsPantryTab = 'MENU_CHEFS_PANTRY_TAB',
  MenuBundlesTab = 'MENU_BUNDLES_TAB',

  // Widget icons
  StatePlus = 'STATE_PLUS',
  StateAlert = 'STATE_ALERT',
  StateCheck = 'STATE_CHECK',
  StateClose = 'STATE_CLOSE',
  StateDelivery = 'STATE_DELIVERY',

  // Order Status Header icons
  OrderStatusHeaderStepAvailable = 'ORDER_STATUS_AVAILABLE',
  OrderStatusHeaderStepConfirmed = 'ORDER_STATUS_CONFIRMED',
  OrderStatusHeaderStepProcessed = 'ORDER_STATUS_PROCESSED',
  OrderStatusHeaderStepProcessedForWines = 'WINES_ORDER_STATUS_PROCESSED',
  OrderStatusHeaderStepShipped = 'ORDER_STATUS_SHIPPED',

  // Order Status Card icons
  ShoppingBasketOutline = 'SHOPPING_BASKET_OUTLINE',
  CheckmarkOutline = 'CHECKMARK_OUTLINE',
  ChefHatOutline = 'CHEF_HAT_OUTLINE',
  PackageDeliveryOutline = 'PACKAGE_DELIVERY_OUTLINE',

  ReceiptOutline = 'RECEIPT_OUTLINE',
  NoResults = 'NO_RESULTS',

  // Orders Manager
  MealDelivery = 'FOOD_BAG_IMAGE',
  CheckedTruck = 'TRUCK_IMAGE',
  CalendarDate = 'CALENDAR_IMAGE',
  PauseClock = 'CLOCK_IMAGE'
}

export enum IconUXPosition {
  Start = 'START',
  End = 'END',
  Up = 'UP',
  Down = 'DOWN'
}

type IconSize = 'small' | 'medium' | 'large'

export type IconAttributes = {
  asset: IconType | Image | string
  color?: Color | ColorValue
  size?: IconSize
}

export type Icon = BaseUXComponent<UXComponentType.Icon> & {
  attributes: IconAttributes
  className?: string
}
